import { useQuery } from '@tanstack/react-query'
import { fetchStoreNames, fetchItemNames } from '@/lib/api/suggestions'

export function useSuggestions() {
  const { data: storeNames = [] } = useQuery<string[]>({
    queryKey: ['suggestions', 'storeNames'],
    queryFn: fetchStoreNames,
    staleTime: 5 * 60 * 1000,
  })

  const { data: itemNames = [] } = useQuery<string[]>({
    queryKey: ['suggestions', 'itemNames'],
    queryFn: fetchItemNames,
    staleTime: 5 * 60 * 1000,
  })

  return { storeNames, itemNames }
}
